import { render } from "./CameraSwitch.vue?vue&type=template&id=3bde018a&scoped=true"
import script from "./CameraSwitch.vue?vue&type=script&lang=js"
export * from "./CameraSwitch.vue?vue&type=script&lang=js"

import "./CameraSwitch.vue?vue&type=style&index=0&id=3bde018a&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bde018a"]])

export default __exports__